<template>
  <div class="media d-flex align-items-center mb-4">
    <img :src="has_src ?  base + uploadedSrc : src"
         alt=""
         id="preview_image" class="rounded-circle avatar-upload mr-3">
    <div class="media-body">
      <label class="file-input">
        <input type="file" style="display: none;" :name="name" @change="handleUploadImage" :required="required">
        <a class="file-input-title d-block text-secondary">
          {{uploaded || has_src ? uploadedTitle : title}}
        </a>
      </label>
      <small class="text-blue-clear d-block" v-if="!uploaded && !has_src">
        {{uploaded ? filename :`Imagen máximo ${size}px`}}
      </small>
    </div>
  </div>
</template>

<script>
  import constants from './../mixins/constants'

  export default {
    name: "upload",
    mixins: [constants],
    props: ['title', 'size', 'name', 'uploaded-title', 'uploaded-src', 'required'],
    data: () => ({
      filename: '',
      src: '/img/avatar-default.svg',
      uploaded: false,
      has_src: false,
    }),
    mounted() {
      if (this.uploadedSrc) {
        this.has_src = true;
      }
    },
    methods: {
      handleUploadImage(ev) {
        const preview = document.getElementById('preview_image');
        const file = ev.target.files[0];
        const reader = new FileReader();
        reader.onloadend = function () {
          preview.src = reader.result;
        };
        if (file) {
          this.uploaded = true;
          this.filename = file.name;
          reader.readAsDataURL(file);
        } else {
          this.uploaded = false;
          preview.src = "";
        }
      }
    }
  }
</script>

<style lang="scss">
  .file-input {
    &-title {
      font-size: 0.845rem;
      cursor: pointer;
    }
  }

  .avatar-upload {
    width: 72px;
    height: 72px;
    object-fit: cover;
  }
</style>

